import SpecialtyButtons from './SpecialtyButtons';

export default SpecialtyButtons;
